'use strict';

var RunNumberService = function RunNumberService(momentService, $filter) {
  var FIRST_RUN = 1;
  var rmMomentFormat = $filter('rmMomentFormat');
  function getPrevRunNumber(currentRunNumber, recommendedFrequency) {
    var currentRunCount = parseInt(currentRunNumber.slice(8, 9));
    var currentRunDate = currentRunNumber.slice(0, 8);
    var previousRunCount, previousRunDate;
    if (currentRunCount === FIRST_RUN) {
      var currentRunDateMoment = momentService.of(currentRunDate, momentService.TYPE.LOCAL_DATE_TIME, momentService.FORMAT.YEAR_MONTH_DAY_NOT_SEPARATED, true);
      var previousRunDateMoment = currentRunDateMoment.subtract(1, 'days');
      previousRunDate = rmMomentFormat(previousRunDateMoment, 'YEAR_MONTH_DAY_NOT_SEPARATED');
      previousRunCount = recommendedFrequency;
    } else {
      previousRunDate = currentRunDate;
      previousRunCount = currentRunCount - 1;
    }
    return previousRunDate + previousRunCount;
  }
  return {
    getPrevRunNumber: getPrevRunNumber
  };
};
RunNumberService.$inject = ['MomentService', '$filter'];
module.exports = RunNumberService;